import React, { useEffect, useRef, useState } from "react";
import { Suspense } from "react"
import ErrorBoundary from "../../../../utils/error-boundary"
import {  Checkbox, Flex, Typography,} from "../../../../ppui"
import { TbCalendarTime, TbCash, TbDeviceDesktopAnalytics, TbMessage2Dollar,  TbMinus,  TbPlus,  TbReportAnalytics, TbUserCog, TbUsersGroup } from "react-icons/tb"
import { TreeStyle, TreeTitle , TreeIcon, TreeSubTitle, TreeSubStyle, ExpandIcon} from "../../../style"
import Ripple from "../../../../ppui/ripple"
import { theme } from "../../../../theme"

const TreeItem = ({ title, icon, to, subItem = [], isNavActive }) => {

  const [isExpanded, setIsExpanded] = useState();
  const [height, setHeight] = useState("0");
  const contentRef = useRef(null);
  const toggleExpanded = () => {
    if (contentRef.current) {
      setIsExpanded(!isExpanded);
      setHeight(
        isExpanded ? "0" : `${contentRef.current.scrollHeight / 16}rem`
      );
    }
  };
  useEffect(() => {
    if (isNavActive === true && contentRef.current) {
      setHeight(`0`);
      setIsExpanded(false);
    }
  }, [isNavActive]);

  return (
    <li className={isExpanded ? "active" : ""}>
      <>
        <TreeTitle
          aria-expanded={isExpanded}
          onClick={() => {
            if (subItem.length > 0) {
              toggleExpanded();
            }
          }}
          to={to}
        >
          <TreeIcon>{icon}</TreeIcon>
          {!isNavActive && (
            <>
              {title}
              <Flex ml={"auto"}>
                <Checkbox size="sm" color="secondary"/>
              </Flex>
              <ExpandIcon>
              {subItem.length > 0 && (
                <>
                  {isExpanded ? <TbMinus /> : <TbPlus />}
                </>
              )}
              </ExpandIcon>
            </>
          )}
          <Ripple color={theme.colors.default.main} duration={1000} />
        </TreeTitle>
        {subItem.length > 0 && (
          <TreeSubStyle
            ref={contentRef}
            sx={{
              maxHeight: height,
            }}
            className={isNavActive && "collapseNav"}
          >
            <ul>
              {subItem.map((link) => (
                <li key={link.to} className={link.class}>
                  <TreeSubTitle to={link.to}>{link.label}
                  <Flex ml={"auto"}>
                    <Checkbox size="sm" color="secondary"/>
                  </Flex>
                  </TreeSubTitle>
                </li>
              ))}
            </ul>
          </TreeSubStyle>
        )}
      </>
    </li>
  );
};


const OrganizationAccessAdmin = () => {
  return (
    <>
      <ErrorBoundary fallback={<div>Something went wrong</div>}>
        <Suspense fallback={<p>loading.....</p>}>
          <Typography variant="h5" >
            Organization Access & Permission
          </Typography>
          <TreeStyle>
            {/* Dashboard */}
            <TreeItem
              icon={<TbDeviceDesktopAnalytics />}
              title="Dashboard"
            />

            {/* Organization */}
            <TreeItem
              icon={<TbUsersGroup />}
              title="Organization"
              subItem={[
                { to: "/employee", label: "Create Employee" },
                { to: "/employee-list", label: "Employee List" },
                { to: "/employee-onboarding", label: "Onboarding Employee" },
                { to: "/employee-permanent", label: "Permanent Employee" },
                { to: "/employee-probation", label: "Probation Period"},
                { to: "/employee-exit", label: "Exit Employee"},
                { to: "/employee-inactive", label: "Inactive Employee"},
              ]}
            />
            {/* Employee */}
            <TreeItem
              icon={<TbUserCog />}
              title="Employee"
              subItem={[
                { to: "/employee", label: "Create Employee" },
                { to: "/employee-list", label: "Employee List" },
                { to: "/employee-onboarding", label: "Onboarding Employee" },
                { to: "/employee-permanent", label: "Permanent Employee" },
                { to: "/employee-probation", label: "Probation Period"},
                { to: "/employee-exit", label: "Exit Employee"},
                { to: "/employee-inactive", label: "Inactive Employee"},
                
              ]}
              
            />


            {/* Time and Attendance */}
            <TreeItem
              icon={<TbCalendarTime />}
              title="Leave & Attendance"
              subItem={[
                { to: "/attendance", label: "Attendance" },
                { to: "/time-tracking", label: "Time Tracking" },
                {
                  to: "/leave-manage",
                  label: "Employee Leave Manage",
                },
                // { to: "/shift-scheduling", label: "Shift Scheduling" },
                // { to: "/overtime", label: "Overtime" },
              ]}
              
            />

            {/* Payroll */}
            <TreeItem
              icon={<TbCash />}
              title="Payroll"
              to="/payroll"
              // subItem={[
              //   { to: "/salary-processing", label: "Salary Processing" },
              //   { to: "/tax-calculations", label: "Tax Calculations" },
              //   { to: "/bonus-incentives", label: "Bonus and Incentives" },
              // ]}
              
            />

            {/* Loan */}
            <TreeItem
              icon={<TbMessage2Dollar />}
              title="Loan"
              to="/loan-list"
              
            />

            {/* Custom Report */}
            <TreeItem
              icon={<TbReportAnalytics />}
              title="Custom Report"
              subItem={[
                { to: "/attendance-report", label: "Attendance Report" },
                { to: "/salary-report", label: "Salary / Wages Report" },
                { to: "/epf-report", label: "EPF Report" },
                { to: "/esi-report", label: "ESI Report" },
                { to: "/pay-slip-report", label: "Pay Slip Report" },
                { to: "/loan-report", label: "Loan Report" },
                { to: "/p-tax-report", label: "P-Tax Report" },
                {
                  to: "/pay-acquiescence-report",
                  label: "Pay Acquiescence Report",
                },
              ]}
              
            />
            <TreeItem
              icon={<TbDeviceDesktopAnalytics />}
              title="Elements"
              to="/elements"
              
            />
          </TreeStyle>

        </Suspense>
      </ErrorBoundary>
    </>
  );
}

export default OrganizationAccessAdmin